<template>
  <div v-if="isload">
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew"
             style="background: url(/img/header_bg.jpg) !important;">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3  text-white">Настройки профиля
                  <span>тут вы можете загрузить аватарку и вписать свои реквизиты :)</span>
                </h1>

              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->


      <div class="row ml-5 mb-5">
        <div class="col-md-5">
          <div class="row ml-5 mb-5" v-if="isload_avatar">
            <img :src="image_url+avatar" class="col-md-4 center-block img img-thumbnail-avatar">
          </div>
          <div class="row ml-5 mb-5">
            <vue-dropzone @vdropzone-success="vdropzone_complete($event)" ref="myVueDropzone" id="dropzone"
                          :options="dropzoneOptions"></vue-dropzone>
          </div>

          <div class="col-12" v-if="loaded_blog_category==true">
            <p>Блоги к которым есть доступ:</p>
            <p><router-link v-if="loaded_blog_category==true"   v-for="(category,category_key) in categorys_blog" :value="category_key"
                         :to="{name: 'category_blog', params: { 'alias':category.alias }}"
                         class="media d-flex align-items-center"
                         tag="a">



                <h6 class="heading text-primary mb-md-1">Блог {{ category.title }}</h6>



            </router-link></p>
          </div>
        </div>
        <div class="col-md-5">
          <div class="alert alert-danger" v-if="iserror==true">
            <p>{{ error_message }}</p>
          </div>
          <form @submit.prevent="onSubmit($event)">
            <div class="form-group">
              <label for="exampleInputEmail1">Реквизиты </label>
              <textarea class="form-control" required id="exampleInputEmail1" v-model="account"
                        placeholder="Введите реквизиты"></textarea>




            </div>

            <div class="form-group mt-5">
              <div class="row">
                <div class="col-6">
                  <label for="exampleInputEmail1">Уведомления на сайте </label>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.site.blogpost_answer_on_comment"/> На ваш комментарий к записи ответили
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.site.blogpost_new_comment"/> К вашей записи написали комментарий
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.site.developer_send_offer"/> Исполнитель отправил свою цену за проект
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.site.new_comment_in_offer_on_project" /> Новый комментарий в проекте на стадии поиска исполнителя
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.site.you_assign_is_developer" /> Сообщение когда вас выбрали исполнителем проекта
                  </div>
                  <div class="row p-1">
                    <input type="checkbox"  v-model="notifys.site.new_comment"/> Новые комментарии в проекте или задаче
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.site.new_comment_on_your_comment" /> Новые ответы к вашим комментариям в проекте или задаче
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.site.developer_create_invoice" /> Исполнитель создал счет
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.site.create_new_task" /> В проекте создали новую задачу.
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.site.project_update" /> Обновлена информация о проекте
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.site.client_accept_condition_on_invoice" /> Условия по счету подтверждены
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.site.change_status" /> Установлен новый статус в проекте или задаче
                  </div>
                  <div class="row p-1">
                    <input type="checkbox"  v-model="notifys.site.invoice_set_complete" /> Условия по счету выполнены
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.site.client_pay_to_invoice" /> Клиент оплатил счет
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.site.invoice_close" /> Счет закрыт
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.site.invite_to_task" /> Приглашение в проект или задачу
                  </div>
                </div>
                <div class="col-6">
                  <label for="exampleInputEmail1">Уведомления  в Telegram </label>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.telegram.blogpost_answer_on_comment"/> На ваш комментарий к записи ответили
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.telegram.blogpost_new_comment"/> К вашей записи написали комментарий
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.telegram.developer_send_offer"/> Исполнитель отправил свою цену за проект
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.telegram.new_comment_in_offer_on_project" /> Новый комментарий в проекте на стадии поиска исполнителя
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.telegram.you_assign_is_developer" /> Сообщение когда вас выбрали исполнителем проекта
                  </div>
                  <div class="row p-1">
                    <input type="checkbox"  v-model="notifys.telegram.new_comment"/> Новые комментарии в проекте или задаче
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.telegram.new_comment_on_your_comment" /> Новые ответы к вашим комментариям в проекте или задаче
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.telegram.developer_create_invoice" /> Исполнитель создал счет
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.telegram.create_new_task" /> В проекте создали новую задачу.
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.telegram.project_update" /> Обновлена информация о проекте
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.telegram.client_accept_condition_on_invoice" /> Условия по счету подтверждены
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.telegram.change_status" /> Установлен новый статус в проекте или задаче
                  </div>
                  <div class="row p-1">
                    <input type="checkbox"  v-model="notifys.telegram.invoice_set_complete" /> Условия по счету выполнены
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.telegram.client_pay_to_invoice" /> Клиент оплатил счет
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.telegram.invoice_close" /> Счет закрыт
                  </div>
                  <div class="row p-1">
                    <input type="checkbox" v-model="notifys.telegram.invite_to_task" /> Приглашение в проект или задачу
                  </div>
                </div>
              </div>


            </div>
            <div class="form-group">
              <button type="submit" class="mt-3 btn btn btn-primary">Сохранить
              </button>
            </div>
          </form>
        </div>

      </div>

    </div>


  </div>
</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Api from "../models/Api";

export default {
  name: "home",

  data() {
    var app = this;


    return {
      "iserror": false,
      "error_message": null,
      'account': '',
      'avatar': "",
      "isload_avatar": false,
      "user": null,
      'image_url': null,
      'isload': false,
      'notifys':{},
      'loaded_blog_category':false,
      'categorys_blog':[],

      dropzoneOptions: {
        url: Vue.config.API_URL + 'uploadavatar',
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>ГРУЗИ АВАТАРКУ СЮДА!",
        headers: {"Authorization": "Bearer " + app.$store.getters.TOKEN},


      }
    }
  },
  mounted() {


    var app = this;
    app.isload = false;
    app.account = '';
    // Код, который будет запущен только после
    // отображения всех представлений


    console.log('setup check');
    console.log(app.$store);
    if (app.$store.getters.USER) {
      console.log('is login true 1');

      var tmp_user = app.$store.getters.USER;
      app.isload = true;
      app.user = tmp_user;

      app.image_url = Vue.config.IMAGE_URL;

      Api.loadBlogCategorys(function (data) {
        app.categorys_blog = data;
        app.loaded_blog_category = true;
      }, app.user.api_token);
      //  console.log('setup data');
      //  console.log(this.$store.getters.USER);
      Api.loadAccount(function(data){
        app.account = data.account;
        app.notifys=data.notifys;
        app.isload = true;
      })
      if (app.user.avatar) {
        app.avatar = app.user.avatar;

        app.isload_avatar = true;
      }
    }else {
      eventBus.$on('user_is_login', user => {
        this.islogin = false;

        if (typeof user === 'object') {


          if("api_token" in user){

            if (user.api_token) {
              console.log('is login true 2');
              var tmp_user=user;


              app.user = tmp_user;
              app.image_url = Vue.config.IMAGE_URL;
              Api.loadBlogCategorys(function (data) {
                app.categorys_blog = data;
                app.loaded_blog_category = true;
              }, app.user.api_token);
              //  console.log('setup data');
              //  console.log(this.$store.getters.USER);
              Api.loadAccount(function(data){
                app.account = data.account;
                app.notifys=data.notifys;
                app.isload = true;
              })

              if (app.user.avatar) {
                app.avatar = app.user.avatar;
                app.isload_avatar = true;
              }




            }
          }
        }


      });
    }


  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
      var app = this;
      var form={};
      form['account']=app.account;
      form['notifys']=app.notifys;
      Api.setAccount(form, function () {
        app.iserror = false;
      }, function (message) {
        app.iserror = true;
        app.error_message = message;
      })


    },
    vdropzone_complete(file) {
      console.log('resp la la la');
      //  console.log(file);
      var response = JSON.parse(file.xhr.response);
      console.log(response.files.file);
      this.avatar = response.files.file;
    }
  },
  components: {vueDropzone: vue2Dropzone}
};
</script>